// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iUmc","option":"styles_option__2KV4U","active":"styles_active__25uqJ"};